import { Check } from 'lucide-react'
import { ComponentPropsWithRef } from 'react'

const CheckboxInput = ({ ...props }: ComponentPropsWithRef<'input'>) => {
  return (
    <div className="relative flex items-center rounded-full">
      <input
        type="checkbox"
        className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:h-10 before:w-10 before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-full before:opacity-0 before:transition-opacity checked:border-brand-green-primary-5 checked:bg-brand-green-primary-5 checked:before:bg-brand-green-primary-5 hover:before:opacity-10"
        {...props}
      />
      <span className="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100">
        <Check size={18} />
      </span>
    </div>
  )
}

export default CheckboxInput
